import React from "react";
import * as Immutable from "immutable";
import { Button, Col, ControlLabel, Form, FormGroup, HelpBlock } from "components/bootstrap";
import TypeSpecificParameterInput from "enterprise/parameters/components/TypeSpecificParameterInput";
export default class ParameterInputForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleValueChange = (name, value) => this.setState({ [name]: value });
    this.handleFormSubmit = (e) => {
      const { onSubmit } = this.props;
      if (e) {
        e.preventDefault();
      }
      onSubmit(Immutable.Map(this.state));
    };
    const values = {};
    props.parameters.valueSeq().forEach((param) => {
      if (!param.needsBinding) {
        return;
      }
      const value = param.binding && param.binding.value || param.defaultValue;
      if (value) {
        values[param.name] = value;
      }
    });
    this.state = values;
  }
  render() {
    const { parameters, searchId } = this.props;
    const parameterInputs = parameters.valueSeq().map((parameter) => {
      const { name, title, description } = parameter;
      const parameterValue = this.state[name] || "";
      return /* @__PURE__ */ React.createElement(FormGroup, { key: `parameter-${name}`, controlId: `parameter-${name}` }, /* @__PURE__ */ React.createElement(Col, { sm: 9, smOffset: 3 }, /* @__PURE__ */ React.createElement(ControlLabel, null, title), /* @__PURE__ */ React.createElement(
        TypeSpecificParameterInput,
        {
          parameter,
          value: parameterValue,
          onChange: this.handleValueChange,
          searchId
        }
      ), /* @__PURE__ */ React.createElement(HelpBlock, null, description)));
    }).toArray();
    return /* @__PURE__ */ React.createElement(Form, { horizontal: true, onSubmit: this.handleFormSubmit }, /* @__PURE__ */ React.createElement(Col, { md: 8, mdOffset: 1 }, parameterInputs), /* @__PURE__ */ React.createElement(Col, { md: 8, mdOffset: 3 }, /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary" }, "Continue")));
  }
}
